import React from 'react';
import {
  Tooltip,
  IconButton,
  Typography,
  styled,
  TooltipProps,
  tooltipClasses,
  Link,
} from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { CustomDivider } from '../custom-divider/CustomDivider';

export interface TooltipProp {
  clickId: string;
  children?: React.ReactNode;
  toolTipTitle?: string;
  toolTipDescription?: string;
  style?: React.CSSProperties;
  youTubeResources?: string;
  docResources?: string;
  toolTipTitleSx?: React.CSSProperties;
  arrow?: boolean;
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
}

export const CustomTooltip: React.FC<TooltipProp> = ({
  clickId,
  toolTipTitle = 'How to use more of it!',
  toolTipDescription,
  youTubeResources,
  docResources,
  children = <HelpOutlineIcon sx={{ fontSize: '1rem' }} />,
  style,
  toolTipTitleSx,
  placement,
  arrow,
}) => {
  const TooltipContent = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      ...style,
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: style?.backgroundColor,
    },
  }));

  return (
    <TooltipContent
      id={`${clickId}_tooltip`}
      enterTouchDelay={0}
      leaveTouchDelay={3000}
      title={
        <React.Fragment>
          <Typography variant="body2" sx={{ ...toolTipTitleSx }}>
            {toolTipTitle}
          </Typography>
          {toolTipDescription && <CustomDivider sx={{ margin: '4px 0' }} />}
          <em> {toolTipDescription} </em>
          {youTubeResources && <CustomDivider sx={{ margin: '4px 0' }} />}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            {youTubeResources && (
              <a
                href={youTubeResources}
                target="_blank"
                rel="noopener noreferrer"
              >
                <u>Watch Video</u>
              </a>
            )}
            {docResources && (
              <a href={docResources} target="_blank" rel="noopener noreferrer">
                <u>View Doc</u>
              </a>
            )}
          </div>
        </React.Fragment>
      }
      placement={placement}
      arrow={arrow}
      PopperProps={{
        onPointerDown: (e) => {
          if (
            e.target instanceof Element &&
            !e.target.classList.contains('MuiTooltip-tooltip')
          ) {
            e.preventDefault();
          }
        },
      }}
    >
      <Link id={`${clickId}_tooltip`}>
        <IconButton aria-label={toolTipTitle} sx={{ padding: 0 }}>
          {children}
        </IconButton>
      </Link>
    </TooltipContent>
  );
};
